/**
 * Project settings control (Story 514; Story 564 moved it)
 *
 * The control in the story list header, beside the Dashboard button, that
 * opens the project settings page. It sits there because that header renders
 * in every workspace state; it used to be in the open story's header, which
 * meant settings could not be reached with no story open. It is about the
 * project, not the signed-in person: there is no account control in the web
 * app's workspace.
 */

import { CogIcon } from '../icons/CogIcon';
import './ProjectSettingsCog.css';

const CONTROL_LABEL = 'Project settings';
const ICON_SIZE = 16;

/** Lets the workspace find the control to give it focus back when settings close. */
export const SETTINGS_ENTRY_ATTRIBUTE = 'data-project-settings-entry';

interface ProjectSettingsCogProps {
  onOpen: () => void;
}

export function ProjectSettingsCog({ onOpen }: ProjectSettingsCogProps) {
  return (
    <button
      type="button"
      className="project-settings-cog"
      aria-label={CONTROL_LABEL}
      title={CONTROL_LABEL}
      onClick={onOpen}
      {...{ [SETTINGS_ENTRY_ATTRIBUTE]: '' }}
    >
      <CogIcon size={ICON_SIZE} />
    </button>
  );
}
